import * as XLSX from 'xlsx'
import ExcelJS from 'exceljs';
// Type imports:
import { IStatusCount } from '../../../types/api/ReportTypes';
import React from 'react';

// ===================================== Format Status Count =====================================
const formatStatusCount = (key: string, value: number) => {
    return (
        <span key={key}>
            {key === "closed" && <><span className={`status-dot closed`}></span>Closed: {value} <br /></>}
            {key === "critical" && <><span className={`status-dot critical`}></span>Critical: {value} <br /></>}
            {key === "explained" && <><span className={`status-dot explained`}></span>Explained: {value} <br /></>}
            {key === "forreview" && <><span className={`status-dot forreview`}></span>For Review: {value} <br /></>}
            {key === "investig" && <><span className={`status-dot investig`}></span>Investig: {value} <br /></>}
            {key === "open" && <><span className={`status-dot open`}></span>Open: {value} <br /></>}
            {key === "watch" && <><span className={`status-dot watch`}></span>Watch: {value} <br /></>}
        </span>
    )
}

// ===================================== Status Count To String =====================================
const statusCountToString = (statusCount: IStatusCount) => {
    return (
        <div>
            {
                Object.entries(statusCount).map(([key, value]) => {
                    if (value === null) return null;
                    return (
                        <span key={key}>
                            {formatStatusCount(key, value)}
                        </span>
                    );
                })
            }
        </div>
    )
}

// ===================================== Export to Excel =====================================
const exportToExcel = async () => {
    const table = document.querySelector('.StickyHeaderTable table');
    const ws = XLSX.utils.table_to_sheet(table);
    let data: any[] = XLSX.utils.sheet_to_json(ws, {header:1});

    // Replace unwanted headers
    data = data.map((row: any) => row.map((header: any) => header === 'TypeAllOrderTradeAlertNewsBookmarkPrivateOrderPrivateTradePrivateTradeReport' ? 'Type' : header));
    data = data.map((row: any) => row.map((header: any) => header === 'CodeAllInsertUpdateDeletedStandardNon-StandardExecutionNewFilledPartiallyFilledCancelledPendingCancelReplacedRejectedTRReceivedUTRSentUTRReceivedBTRSentBTRRejectTRCancelTRBrokenTRMatched' ? 'Code' : header));
    data = data.map((row: any) => row.map((header: any) => header === 'SideAllBid / BuyAsk / Sell' ? 'Side' : header));

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Alert Summary');

    // Add data to worksheet
    data.forEach((row: any[], rowIndex) => {
        row.forEach((value: any, colIndex) => {
            const cell = worksheet.getCell(rowIndex + 1, colIndex + 1);
            cell.value = value;

            // Make headers bold
            if (rowIndex === 0) {
                cell.font = { bold: true };
            }
        });
    });

    // Adjust column widths
    worksheet.columns.forEach(column => {
        let maxColumnLength = 0;
        if (column && column.eachCell) {
            column.eachCell({ includeEmpty: true }, cell => {
                const columnLength = cell.text.length;
                if (columnLength > maxColumnLength) {
                    maxColumnLength = columnLength;
                }
            });
        }
        column.width = maxColumnLength < 10 ? 10 : maxColumnLength;
    });

    // Write to file
    workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `alert_summary.xlsx`;
        a.click();
    });
}

export {
    formatStatusCount,
    statusCountToString,
    exportToExcel
}